import { useAppDispatch } from '@/app/hooks';
import { openSusFormDrawer } from '@/features/drawer/drawerSlice';
import { ActionIcon, Tooltip } from '@mantine/core';
import { IconEdit } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';

type Props = {
  /** Id du service d'urgence à éditer ; ses données sont chargées à l'ouverture du formulaire. */
  id: number;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
};

const SusEditButton = ({ id, size }: Props) => {
  const { t } = useTranslate();
  const dispatch = useAppDispatch();

  const iconSize =
    size === 'xs' ? 12 : size === 'sm' ? 14 : size === 'md' ? 16 : size === 'lg' ? 18 : 20;

  return (
    <Tooltip label={t('admin.sus.edit')} withArrow>
      <ActionIcon
        variant="subtle"
        aria-label={t('admin.sus.edit')}
        size={size}
        onClick={() => dispatch(openSusFormDrawer(t('admin.sus.edit'), id))}
      >
        <IconEdit size={iconSize} stroke={1.5} />
      </ActionIcon>
    </Tooltip>
  );
};

export default SusEditButton;
